import friendlyDate from '../../Utils/FriendlyDate';
import t from "../../Utils/Translation";
import './timelineBox.css'

const TimelineBox = (props)=>{
    const userHistoryItems = props.userHistoryItems;
    
    return <div className=" lykiocss-profile-text-color"  style={{paddingRight: '0px', paddingLeft: '0px'}}>
            <div className="card">
                <div className="card-block" >
                    <div className="row align-items-center justify-content-center">
                        <div className="col">
                            <div className='lykiocss-center lykiocss-subtitle-light'>{t("Timeline (last 5 entries)")}</div>
                        </div>
                    </div>
                    <ul className="task-list">
                        {userHistoryItems && userHistoryItems.slice(0).reverse().map((historyItem, index) =>{
                            if(index<5){
                                return <li>
                                <i className="task-icon bg-c-blue"></i>
                                <span className="float-right">{localStorage.getItem("i18n") === "it" ? historyItem.message.replace("viewed", "visualizzato il post")
                                .replace("logged in","effettuato l’accesso")
                                .replace("created","creato") : historyItem.message }</span>
                                <p className="text-muted">{t("on")} {friendlyDate(historyItem.creationDate)}</p>
                                </li>
                            }
                        })}
                    </ul>
                </div>
            </div>
        </div>
}

export default TimelineBox;